// extracted by mini-css-extract-plugin
export default {"results":"ComparisionReporting_results__GADyl"};